<template>
  <div class="page-head">
    <a href="javascript:;" class="head-logo">
      <img class="logo-100" src="../assets/logo-s.png" alt="" @click="gohome">
    </a>
    <div class="head-menus-div">
      <div class="head-menus">
        <template>
          <a href="javascript:;" class="menu-1" @click="clickLeftMenu('left')" :class="{'menu-1-active': show_menu === 'left'}" v-if="solutionStatus > 10 || solutionStatus === 10">
            <i class="iconfont icon-dingdan"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" href="javascript:;" key="index" class="menu-one" v-for="(menu, index) in left_menus" @click="chooseMenu(menu)" v-if="solutionStatus > menu.minStatus || solutionStatus === menu.minStatus">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
          <div class="fg-line" v-if="solutionStatus > 30 || solutionStatus === 30">
          </div>
          <a  href="javascript:;"class="menu-1" @click="clickLeftMenu('right')" :class="{'menu-1-active': show_menu === 'right'}" v-if="solutionStatus > 30 || solutionStatus === 30">
            <i class="iconfont icon-shuju"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" key="index + '-right'" href="javascript:;" class="menu-one" v-for="(menu, index) in right_menus" v-if="solutionStatus > menu.minStatus || solutionStatus === menu.minStatus" @click="chooseMenu(menu)">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
        </template>
      </div>
    </div>
    <div class="head-user">
      <div class="user-info" v-if="login">
        <i class="iconfont icon-user"></i>
        <div class="fg-line-2">
        </div>
        <a href="javascript:;" @click="loginOut">安全退出</a>
      </div>
      <div class="user-info" v-else>
        <a href="javascript:;" @click="goLogin">登录</a>
      </div>
    </div>
    <div style="display: none">
      {{path}}
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        active_menu_index: null,
        show_menu: '',
        active_menu: '',
        left_menus: [],
        right_menus: [],
        left_menus_p: [],
        right_menus_p: [],
        other_menus: [],
        menus: [{
          leabel: '订单相关信息',
          minStatus: 10,
          type: 'left',
          route_name: 'source_data_to'
        },
        {
          leabel: '分析预测',
          type: 'left',
          minStatus: 10,
          route_name: 'prediction_to'
        },
        {
          leabel: '车辆相关信息',
          minStatus: 30,
          type: 'right',
          route_name: 'cars_to'
        },
        {
          leabel: '路径相关信息',
          minStatus: 40,
          type: 'right',
          route_name: 'car_route_to'
        }]
      }
    },
    computed: {
      path: {
        get () {
          let path = this.$store.state.route.path
          let vm = this
          this.active_menu = this.$router.history.current.name
          this.menus.forEach(function (item, index) {
            if (vm.active_menu === item.route_name) {
              vm.show_menu = item.type.indexOf('pre_') > -1 ? item.type.slice(4) : item.type
            }
          })
          return path
        }
      },
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      preStatus: {
        get () {
          return this.$store.getters.preStatus
        }
      },
      login: {
        get () {
          return this.$store.getters.login
        }
      }
    },
    created () {
      let vm = this
      this.menus.forEach(function (item) {
        if (item.type === 'left') {
          vm.left_menus.push(item)
        } else if (item.type === 'right') {
          vm.right_menus.push(item)
        } else if (item.type === 'pre_left') {
          vm.left_menus_p.push(item)
        } else if (item.type === 'pre_right') {
          vm.right_menus_p.push(item)
        }
      })
    },
    methods: {
      loginOut () {
        this.$store.dispatch('loginOut')
      },
      goLogin () {
        this.$store.dispatch('setLoginFor', this.path)
        this.$router.push('/login')
      },
      gohome () {
        this.$router.push({ name: 'index' })
      },
      clickLeftMenu (key) {
        this.show_menu = key
      },
      chooseMenu (menu) {
        this.active_menu = menu.route_name
        this.show_menu = menu.type.indexOf('pre') > -1 ? menu.type.slice(4) : menu.type
        this.$router.push({ name: menu.route_name })
      },
      chooseMenuIndex (index) {
        this.active_menu_index = index
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  @left-right-width: 13em;
  .menu-index {
    height: 2.63em;
    .menu-one {
      margin: 2px 4em 0;
      font-size: 1.2em;
    }
    .active-menu-one {
      color: @line-color;
      border-bottom: 0.31em solid @line-color;
      padding-bottom: 0.6em;
    }
  }
  .page-head {
    height: 6.13em;
    background-color: @bak-color-1;
    display: flex;
    flex-direction: row;
  }
  .head-logo {
    width: @left-right-width;
    align-items: center;
    justify-content: center;
    display: flex;
    padding: 0 0 0.5em 1.5em;
  }
  .logo-100 {
    height: 5.6em;
  }
  .head-menus-div {
    flex: 1;
    display: flex;
    flex-direction:column-reverse;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to {
    opacity: 0;
  }
  .head-menus {
    color: #fff;
    display: flex;
    flex-direction:row;
    justify-content:center;
  }
  .head-user {
    width: @left-right-width;
  }
  .fg-line {
    width: 2px;
    margin:-0.31em 1.625em 1.13em;
    background-color: #fff;
  }
  .fg-line-2 {
    width: 2px;
    margin:0.625em 0.44em;
    background-color: #fff;
  }
  .menu-1 {
    transition: 0.3s;
    display: flex;
    flex-direction:row;
    margin: 0 0.625em;
    color: #fff;
    line-height: 1;
    padding-bottom: 1.13em;
    .iconfont {
      font-size: 1.56em;
    }
    span {
      font-size: 1.5em;
      margin-left: 0.625em;
    }
  }
  .menu-1-active {
    color: @line-color;
  }
  .menu-2 {
    display: flex;
    flex-direction:row;
  }
  .menu-one {
    transition: 0.3s;
    color: #fff;
    flex: 1;
    font-size: 0.9em;
    word-break: keep-all;
    white-space: nowrap;
    margin: 2px 0.625em 0;
  }
  .active-menu-one {
    color: @line-color;
    border-bottom: 0.31em solid @line-color;
    padding-bottom: 1.15em;
  }
  .head-user {
    display: flex;
    flex-direction:column-reverse;
  }
  .user-info {
    margin:0 1.88em 0.94em 0;
    color: #fff;
    display: flex;
    flex-direction:row;
    justify-content: flex-end;
    a {
      color: #fff;
      margin-top: 0.44em;
    }
    i {
      font-size: 2.06em;
    }
  }
</style>



// WEBPACK FOOTER //
// PageHeadTo.vue?06e92b28